import { InteractiveTutorial, InteractiveTutorialProps } from "@/features/interactive_tutorial";
import DeleteOutlined from "@ant-design/icons/es/icons/DeleteOutlined";
import { Image, TourStepProps } from "antd";
const steps: TourStepProps[] = [{
  title: "Hide Fields",
  description: <>
        <p>
          Click on <b>Hide Fields</b> to show toggles to hide or un-hide unnecessary table columns for ease of viewing.
        </p>
        <Image alt="Shows menu displayed when clicking the Hide Fields menu item." src="/_/img/tours/database/step_2.jpg" />
      </>
}, {
  title: "Filter",
  description: <>
        <p>
          Click on <b>Filter</b>, and <b>+ Add condition</b> to add a conditional filter.
        </p>
        <Image alt="Shows menu displayed when clicking the Filter menu item." src="/_/img/tours/database/step_3a.jpg" />
      </>
}, {
  title: "Example: Filter",
  description: <>
        <p className="prose">
          For example, the results below have been filtered by a time <b>Period</b> and <b>Data Source</b>, with time
          period set to since 1988, and data provided by the Hong Kong Observatory.
          <ul>
            <li>
              Filter records by choosing a Field from the dropdown next to <b>Where</b>.
            </li>
            <li>
              In the second dropdown, choose an operator to sort by, ie. <b>is</b> or <b>contains</b>.
            </li>
            <li>In the third dropdown, choose an option or enter a value you wish to refine records by.</li>
            <li>
              Add more conditions by clicking <b>+ Add condition</b>, and applying <b>and</b> / <b>or</b> conditions to
              add more filters to results.
            </li>
            <li>
              Use the trash can icon <DeleteOutlined /> to delete a filter.
            </li>
            <li>
              To refine even further, Click on <b>+ Add condition group</b> , and drag conditional line items via the ⠿
              button. This allows you to overlay many conditional searches.
            </li>
          </ul>
        </p>
        <Image alt="Shows filled-out menu displayed when clicking the Filter menu item." src="/_/img/tours/database/step_3b.jpg" />
      </>
}, {
  title: "Group",
  description: <>
        <p>
          Click <b>Group</b> to group data by field, and sort group results from
          <b>first - last</b>, or <b>last - first</b> order.
        </p>
        <Image alt="The Group menu item is displayed." src="/_/img/tours/database/step_10.jpg" />
      </>
}, {
  title: "Sort",
  description: <>
        <p>
          <b>Sort</b> allows you to sort records by field.
        </p>
        <Image alt="The Sort option is displayed." src="/_/img/tours/database/step_11.jpg" />
      </>
}, {
  title: "Row Height",
  description: <>
        <p>Click on the row height icon to adjust row height in table window.</p>
        <Image alt="Row height is adjusted by the second-last option the tool menu." src="/_/img/tours/database/step_12.jpg" />
      </>
}, {
  title: "Source Link",
  description: <>
        <p>
          Under column field <b>Source Link</b> on the furthest right of the table, you will find source links to
          external datasets.
        </p>
        <Image alt="Sources are in the Source Link column." src="/_/img/tours/database/step_13.jpg" />
      </>
}, {
  title: "Data",
  description: <>
        <p>
          Where the data is available in an easily accessible format, it will appear in the <b>Data</b>
          column. Click on the thumbnails to expand the content to full screen view.
        </p>
        <Image alt="Data column may contain visual references." src="/_/img/tours/database/step_14.jpg" />
      </>
}, {
  title: "Download",
  description: <>
        <p>Download a .csv of data for further reference.</p>
        <Image alt="Click triple fots menu item to reveal Download CSV option." src="/_/img/tours/database/step_15.jpg" />
      </>
}];
export const DatabaseTutorial = (props: InteractiveTutorialProps<Record<any, any>>) => {
  return <InteractiveTutorial<Record<any, any>> isWide={true} steps={steps} {...props} data-sentry-element="InteractiveTutorial" data-sentry-component="DatabaseTutorial" data-sentry-source-file="tutorial.tsx" />;
};